import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";

async function list(params) {
  return await request({
    url: ENDPOINT.ARTIFACTS,
    method: "get",
    params,
  });
}

async function show(id) {
  return await request({
    url: `${ENDPOINT.ARTIFACTS}/${id}`,
    method: "get",
  });
}

async function create(data) {
  return await request({
    url: ENDPOINT.ARTIFACTS,
    method: "post",
    data,
  });
}

async function update(data) {
  return await request({
    url: `${ENDPOINT.ARTIFACTS}/${data.id}`,
    method: "patch",
    data,
  });
}

async function updateMultiple(data) {
  return await request({
    url: `${ENDPOINT.ARTIFACTS}`,
    method: "patch",
    data,
  });
}

async function remove(data) {
  return await request({
    url: `${ENDPOINT.ARTIFACTS}/${data.id}`,
    method: "delete",
    data,
  });
}

export default {
  list,
  show,
  create,
  update,
  updateMultiple,
  remove,
};
